import omit from 'lodash/omit';
import noop from 'lodash/noop';
import React, { Component } from 'react';
import PropTypes from 'prop-types';

const withFocusOnMount = (ComponentToWrap)=> {
  class WrappedWithFocusOnMount extends Component {
    componentDidMount() {
      if (this.props.focusOnMount && this.ref) {
        if (this.props.shouldSelect) {
          $(this.ref).one('focus', ()=> {
            $(this.ref).select();
          });
        }
        this.ref.focus();
      }
    }
    render() {
      return <ComponentToWrap 
        ref={(ref)=> { this.ref = ref; this.props.onRefMount(ref); }} 
        {...omit(this.props, ['shouldSelect', 'focusOnMount', 'onRefMount'])} 
      />;
    }
  }
  WrappedWithFocusOnMount.propTypes = {
    focusOnMount: PropTypes.bool,
    shouldSelect: PropTypes.bool,
    onRefMount: PropTypes.func
  };
  WrappedWithFocusOnMount.defaultProps = {
    focusOnMount: false,
    shouldSelect: false,
    onRefMount: noop
  };
  return WrappedWithFocusOnMount;
};

export default withFocusOnMount;